import { useFormik } from "formik";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { InputField } from "src/components";
import { useCreateLookupInfoMutation } from "src/rtk/features/setup/lookup/lookupInfoApi";
import * as Yup from 'yup';

const initialValues: LookupInfo = {
  lookup_code: '',
  lookup_name: '',
  status: '',
};

const AddLookup = (props: any) => {
  const { isOpen, toggle } = props;

  const [createLookupInfo, { isSuccess, isError, error }] = useCreateLookupInfoMutation();

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      lookup_code: Yup.string().required('Lookup Code is required'),
      lookup_name: Yup.string().required('Lookup Name is required'),
    }),
    onSubmit: (values) => {
      // Handle form submission logic here
      console.log('Form submitted:', values);
      createLookupInfo(values);
    },
  });
  const { handleChange, handleSubmit, getFieldProps, values, errors, touched, resetForm } = formik;

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Lookup created successfully');
      toggle();
    }
    if (isError) {
      toast.error('Error creating lookup');
    }
  }, [isSuccess, isError]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Lookup Info</ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <ModalBody>
          <div>
            <FormGroup className="mb-3">
              <Label for="lookup_code">Lookup Code</Label>
              <InputField
                type="text"
                placeholder="Lookup Code"
                {...getFieldProps('lookup_code')}
                invalid={{ errors, touched }}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label for="lookup_name">Lookup Name</Label>
              <InputField
                type="text"
                placeholder="Lookup Name"
                {...getFieldProps('lookup_name')}
                invalid={{ errors, touched }}
              />
            </FormGroup>
            <FormGroup switch className="mb-3">
              <Input
                type="switch"
                role="switch"
                placeholder="Status"
                {...getFieldProps('status')}
              />
              <Label for="status">Active Status</Label>
            </FormGroup>

          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default AddLookup;